import { createContext, useContext } from 'react';

/**
 * SparkContext — carries the current spark + space identity down the component tree.
 *
 * Replaces manual prop-drilling of `space`, `space_id`, `chat_id`, `isNewChat`,
 * and `isNewChatWithSpace` through MainContent → Prompt → ChatMessages → SingleMessage.
 *
 * Value shape:
 *   chat_id           — active chat/spark ID (from URL params)
 *   space_id          — Spectra space ID, or null for private sparks
 *   space             — full space object (from useSpectraById), or null
 *   isNewChat         — true when this chat hasn't been saved to Firestore yet
 *   isNewChatWithSpace — true when isNewChat && space_id (new chat inside a Spectra)
 *   isPersisted       — true when the chat document has been loaded from Firestore
 *   user_id           — current user's UID
 */
const SparkContext = createContext({
  chat_id: null,
  space_id: null,
  space: null,
  isNewChat: false,
  isNewChatWithSpace: false,
  isPersisted: false,
  user_id: null,
});

export const useSparkContext = () => useContext(SparkContext);

export default SparkContext;
